import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "gfu-project-summary-stats-bg" }
const _hoisted_3 = { class: "gfu-project-summary-stats__title" }
const _hoisted_4 = {
  class: "gfu-hd gfu-hd--h4 _tc--inherit _ttu",
  "data-qa": "project-summary-stats:ProjectOutcome"
}
const _hoisted_5 = { class: "gfu-project-summary-stats__content" }
const _hoisted_6 = { class: "_mt-3" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "_mt-4" }
const _hoisted_9 = {
  class: "_mt-4",
  "data-qa": "project-summary-stats:BackersCount"
}
const _hoisted_10 = { "format-key": "0" }
const _hoisted_11 = { "format-key": "0" }
const _hoisted_12 = {
  key: 1,
  "data-qa": "project-summary-stats:PercentageOfGoal"
}
const _hoisted_13 = { "format-key": "0" }
const _hoisted_14 = { "format-key": "0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_project_summary_completed_stats_funded = _resolveComponent("project-summary-completed-stats-funded")
  const _component_localize = _resolveComponent("localize")
  const _component_display_currency_value = _resolveComponent("display-currency-value")
  const _component_project_summary_follow = _resolveComponent("project-summary-follow")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-project-summary-stats', {
             'gfu-project-summary-stats--funded': $options.wasCampaignSuccessful,
             'gfu-project-summary-stats--update': $props.hasUpdate
         }]),
    "data-qa": `project-summary-stats:${$options.wasCampaignSuccessful}`
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.icons, (icon) => {
        return (_openBlock(), _createBlock(_component_base_icon, {
          key: icon.iconName,
          name: icon.iconName,
          class: _normalizeClass(icon.className)
        }, null, 8 /* PROPS */, ["name", "class"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h6", _hoisted_4, _toDisplayString($options.title), 1 /* TEXT */)
    ]),
    ($options.wasCampaignSuccessful)
      ? (_openBlock(), _createBlock(_component_project_summary_completed_stats_funded, _normalizeProps(_mergeProps({ key: 0 }, $options.projectSummaryStatsFundedProps)), null, 16 /* FULL_PROPS */))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString($options.reason), 1 /* TEXT */),
            ($options.showNoFundsCollectedCopy)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryStatisticsNoFundsCollectedText), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.Resources.format(_ctx.Resources.ProjectHome.ProjectSummaryStatisticsEndDateText, $options.campaignEndedAt)), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_localize, {
                resource: _ctx.Resources.ProjectHome.ProjectSummaryStatisticsBackerCountText
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.Resources.pluralize($props.backersCount, _ctx.Resources.ProjectHome.ProjectSummaryProgressPluralizedBacker)), 1 /* TEXT */),
                  _createVNode(_component_display_currency_value, {
                    class: "_flexinline _ai-c",
                    "icon-classes": "gfu-icon--medium",
                    "format-key": "1",
                    tag: "span",
                    variant: "surface",
                    "data-qa": "project-summary-stats:FundsGathered"
                  }, {
                    "tooltip-content": _withCtx(() => [
                      _createVNode(_component_localize, {
                        resource: _ctx.Resources.ProjectHome.ProjectApproximateCurrencyConversionTooltip
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$format($props.fundsGathered, 'C0')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["resource"])
                    ]),
                    content: _withCtx(({ displayCurrency }) => [
                      _createTextVNode(_toDisplayString(_ctx.$format($props.fundsGathered / displayCurrency.relativeFactor, 'C0', displayCurrency.symbol)), 1 /* TEXT */)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$format($props.fundsGathered, 'C0')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["resource"])
            ]),
            (!_ctx.isExpressCrowdfundingOriginalType)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_localize, {
                    resource: _ctx.Resources.ProjectHome.ProjectSummaryStatisticsPercentageOfGoalText
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_13, _toDisplayString($options.percentageOfGoal), 1 /* TEXT */),
                      _createVNode(_component_display_currency_value, {
                        class: "_flexinline _ai-c",
                        "icon-classes": "gfu-icon--medium",
                        "format-key": "1",
                        tag: "strong",
                        variant: "surface"
                      }, {
                        "tooltip-content": _withCtx(() => [
                          _createVNode(_component_localize, {
                            resource: _ctx.Resources.ProjectHome.ProjectApproximateCurrencyConversionTooltip
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$format($props.campaignGoal, 'C0')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["resource"])
                        ]),
                        content: _withCtx(({ displayCurrency }) => [
                          _createTextVNode(_toDisplayString(_ctx.$format($props.campaignGoal / displayCurrency.relativeFactor, 'C0', displayCurrency.symbol)), 1 /* TEXT */)
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$format($props.campaignGoal, 'C0')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["resource"])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createVNode(_component_project_summary_follow, {
            theme: "inverse",
            "button-theme": "transparentInverse",
            class: "_mt-4"
          })
        ], 64 /* STABLE_FRAGMENT */))
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}